// @flow

import { createSelector } from 'reselect';

import { selectOneProduct } from '@gandi/cart';

import type { FullState } from '../../../types';
import type { ResultsState, Result, ResultItem } from '../../types';

const EMPTY_OBJECT = {};

const selectRaw = (state: FullState): ResultsState =>
  state.domainTransfer.results || EMPTY_OBJECT;

const augmentResult: (state: FullState, result: Result) => ResultItem =
  // $FlowIgnore[incompatible-call]
  createSelector(
    [
      (state, result) => selectOneProduct(state, { fqdn: result.fqdn }),
      (_, result) => result,
    ],
    (product, result) => {
      if (!product || !product.id) {
        return result;
      }

      return {
        ...result,
        addedToCart: true,
      };
    },
  );

export const selectResults = (state: FullState): Array<ResultItem> =>
  Object.values(selectRaw(state)).map(augmentResult.bind(null, state));

export const selectOneResult: (
  state: FullState,
  fqdn: string,
) => Result | void = createSelector(
  [selectRaw, (_, fqdn) => fqdn],
  (raw: ResultsState, fqdn: string): Result | void =>
    raw[fqdn] || Object.values(raw).find(result => result.term === fqdn),
);

export const selectOneResultItem = (
  state: FullState,
  fqdn: string,
): ResultItem | void => {
  const result = selectOneResult(state, fqdn);
  return result ? augmentResult(state, result) : undefined;
};

// $FlowFixMe[cannot-resolve-name]
export const selectHasResults: OutputSelector<FullState, mixed, boolean> =
  createSelector([selectRaw], results => Object.keys(results).length > 0);

// $FlowFixMe[cannot-resolve-name]
export const selectHasCorporateTLDs: OutputSelector<FullState, mixed, boolean> =
  createSelector(
    [selectRaw],
    results =>
      Object.values(results).filter(result => result.corporate).length > 0,
  );
